import { useEffect, useState } from "react";

export function useResizeObserverHeight(ref: React.RefObject<HTMLElement | null>) {
    const [height, setHeight] = useState<number>(0);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const ro = new ResizeObserver(entries => {
            for (const entry of entries) {
                const box = entry.contentRect;
                setHeight(box.height);
            }
        });
        ro.observe(el);
        setHeight(el.getBoundingClientRect().height);

        return () => ro.disconnect();
    }, [ref]);

    return height;
}
